const formStepsMixin = {
    data: () => {
        return {
            stepsLength: 0,
            currentStepIndex: 0,
        };
    },

    computed: {
        getStepLength() {
            return this.uPad(this.stepsLength);
        },
        getCurrentIndex() {
            return this.uPad(this.currentStepIndex + 1);
        },
        isPrevAvailable() {
            return this.currentStepIndex > 0;
        },
        isNextAvailable() {
            const currentValidationObj = this.$v[`step${this.currentStepIndex + 1}`];
            return (
                this.currentStepIndex < this.stepsLength &&
                !currentValidationObj.$invalid
            );
        },
    },

    created() {
        this.steps = [];
    },
    mounted() {
        /////////////////////////
        // Declarations
        this.$steps = this.$el.querySelectorAll(".js-steps-item");
        this.$stepsWrapper = this.$el.querySelector(".js-steps-wrapper");
        this.$stepsDescriptions = this.$el.querySelectorAll(".js-steps-description");
        this.$stepsDescriptionsWrapper = this.$el.querySelector(".js-steps-description-wrapper");

        /////////////////////////
        // Events
        this.bindEvents()

        /////////////////////////
        // Run
        this.setSteps();
        this.onResize();
    },

    beforeDestroy() {
        this.unbindEvents()
    },

    methods: {
        initForm() {
            // Set initial values
            this.moduleInstance.initialValues && this.setInitialValues(this.moduleInstance.initialValues)
        },
        setInitialValues(values) {
            // Add data into each step
            values.forEach((stepObj, index) => {
                const step = this[`step${index + 1}`]
                if (step) {
                    this[`step${index + 1}`] = {...step , ...stepObj }
                }
            })
        },

        /////////////////////////
        // Binding
        bindEvents() {
            // this.resizeBind = this.onResize.bind(this);
            // window.addEventListener("resize", this.resizeBind);
        },

        unbindEvents() {
            // window.removeEventListener("resize", this.resizeBind);
        },

        /////////////////////////
        // Callbacks
        onPrevStep() {
            if (!this.isPrevAvailable) return;
            this.currentStepIndex--;
            window.scrollTo(0, 0);
            // this.animeWrapperHeight()
            // this.animeDescriptionWrapperHeight()
        },

        onNextStep(e) {
            const currentValidationObj = this.$v[`step${this.currentStepIndex + 1}`];
            currentValidationObj.$touch()

            // Scroll to invalid field
            if (currentValidationObj.$invalid) {
                this.$nextTick(() => {
                    this.computeWrapperHeight();
                    const getInvalidFields = this.$el.querySelectorAll('.c-form_item.is-invalid')
                    if (getInvalidFields.length) {
                        this.moduleInstance && this.moduleInstance.call('scrollTo', [getInvalidFields[0]], 'Scroll')
                    }
                })
                return
            }

            //if (!this.isNextAvailable) return;

            if (this.currentStepIndex === this.stepsLength - 1) {
                // Submit
                this.submit && this.submit(e)
            } else {
                this.currentStepIndex++;
                this.animeWrapperHeight()
                this.animeDescriptionWrapperHeight()
                window.scrollTo(0, 0);
            }
        },

        onResize() {
            // this.$nextTick(() => {
            //     this.computeWrapperHeight();
            //     this.computeDescriptionWrapperHeight();
            // })
        },

        /////////////////////////
        // Methods
        setSteps() {
            // Hydrate steps array
            this.$steps.forEach((step, index) => {
                this.steps.push({
                    index: index,
                    item: step,
                    isValid: false,
                });
            });

            // Set stepsLength
            this.stepsLength = this.steps.length;
        },

        computeWrapperHeight() {
            // const $currentStep = this.$steps[this.currentStepIndex];
            // const $currentStepHeight = $currentStep.offsetHeight;
            // this.$stepsWrapper.style.height = `${$currentStepHeight}px`;
        },

        computeDescriptionWrapperHeight() {
            // const $currentDescription = this.$stepsDescriptions[this.currentStepIndex];
            // if (!$currentDescription) return
            // const $currentDescriptionHeight = $currentDescription.offsetHeight;
            // this.$stepsDescriptionsWrapper.style.height = `${$currentDescriptionHeight}px`;
        },

        /////////////////////////
        // Animations
        animeWrapperHeight() {
            // const $currentStep = this.$steps[this.currentStepIndex];
            // const $currentStepHeight = $currentStep.offsetHeight;
            // gsap.to(this.$stepsWrapper, .3, {
            //     height: $currentStepHeight,
            //     onComplete: () => {
            //         this.moduleInstance && this.moduleInstance.call('update', null, 'Scroll')
            //         this.moduleInstance && this.moduleInstance.call('scrollTo', [this.$el], 'Scroll')
            //     }
            // })
        },

        animeDescriptionWrapperHeight() {
            // const $currentDescription = this.$stepsDescriptions[this.currentStepIndex];
            // if (!$currentDescription) return
            // const $currentDescriptionHeight = $currentDescription.offsetHeight;
            // gsap.to(this.$stepsDescriptionsWrapper, .3, {
            //     height: $currentDescriptionHeight,
            //     onComplete: () => {
            //         this.moduleInstance && this.moduleInstance.call('update', null, 'Scroll')
            //     }
            // })
        },

        /////////////////////////
        // Utils
        uPad(number) {
            return number < 10 ? "0" + number.toString() : number.toString();
        },
    },
};

export default formStepsMixin;
